/**
 * Created by piotr.pozniak@thebeaverhead.com on 23/07/2021.
 */
import PageTemplate from "../templates/PageTemplate";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import appConfig from "../../../appConfig";

/**
 *
 * @param {string} size
 * @param {function} onClose
 * @param {string} header
 * @param {string} title
 * @param {string} id
 * @param {string} sidebarId
 * @param {Element} children
 * @returns {Element}
 * @constructor
 */
const ModalTemplate = ({
  size = "md",
  onClose,
  header,
  id,
  sidebarId,
  children,
  title,
}) => {
  const history = useHistory();

  useEffect(() => {
    const handleModal = () => {
      window.$("#" + id).modal("show");

      return () => {
        window.$("#" + id).modal("hide");
        setTimeout(() => {
          window.$(".modal-backdrop.fade.show").remove();
          document.body.className = document.body.className.replace(
            "modal-open",
            ""
          );
        }, 300);
      };
    };

    return handleModal();
  }, []);

  /**
   *
   * @param e
   * @returns {boolean|*}
   */
  const _onClose = (e) => {
    // console.log("onClose");
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (onClose) {
      return onClose();
    }

    history.goBack();

    return false;
  };

  return (
    <PageTemplate sidebarId={sidebarId} title={title}>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div
            id={id}
            className={classnames("modal custom-modal fade")}
            role="dialog"
            data-backdrop="static"
          >
            <div className="modal-dialog">
              <div className={classnames("modal-content", "modal-" + size)}>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={_onClose}
                >
                  ×
                </button>
                <div className="modal-header">
                  <h4 className="modal-title visible-xs">
                    <img
                      src={`/img/branding/${appConfig.branding}/icon/ms-icon-310x310.png`}
                      width={24}
                      height={24}
                      className={"m-r-5"}
                    />
                    {header}
                  </h4>
                </div>
                <div className="modal-body">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default ModalTemplate;
